import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { SupportedLocale } from "@/i18n";
import { computeFieldCollectorNameForOverview } from "@/lib/computeFields";
import { Tirage } from "@/lib/types";
import { MergedDisplayData } from "../types";
import { TirageDrawer } from "./TirageDrawer";

interface TiragesAccordionProps {
  displayData: MergedDisplayData;
  isTirage: boolean;
  isPhotoModuleEnabled: boolean;
  locale: SupportedLocale;
  t: (key: string) => string;
}

export function TiragesAccordion({
  displayData,
  isTirage,
  isPhotoModuleEnabled,
  locale,
  t,
}: TiragesAccordionProps) {
  // Only show Tirages accordion if:
  // 1. Not currently displaying a tirage itself
  // 2. Has tirages to display
  // 3. Photo module is enabled (which also implies artwork is photography type)
  if (
    isTirage ||
    !displayData.Tirage ||
    displayData.Tirage.length === 0 ||
    !isPhotoModuleEnabled
  ) {
    return null;
  }

  return (
    <AccordionItem value="tirages">
      <AccordionTrigger>{t("singleArtworkSubtitleTirages")}</AccordionTrigger>
      <AccordionContent className="flex flex-col gap-4 w-full">
        {displayData.Tirage.map((tirage: Tirage) => {
          // Simple tirage summary for the trigger
          const tirageSummary = [
            tirage.tirageDescriptionNumeroEnregistrement,
            tirage.tirageDescriptionType?.[locale],
            tirage.tirageDescriptionDateCreation &&
              `(${tirage.tirageDescriptionDateCreation})`,
            computeFieldCollectorNameForOverview(
              {
                collectionneursDescriptionNom:
                  tirage.collector?.collectionneursDescriptionNom ?? "",
                collectionneursDescriptionPrenom:
                  tirage.collector?.collectionneursDescriptionPrenom ?? "",
                collectionneursDescriptionCollectionPublique:
                  tirage.collector
                    ?.collectionneursDescriptionCollectionPublique ?? false,
                collectionneursDescriptionVille:
                  tirage.collector?.collectionneursDescriptionVille ?? "",
                showCity: true,
              },
              { language: locale, translation: t },
            ),
          ]
            .filter(Boolean)
            .join(", ");

          return (
            <TirageDrawer
              key={tirage.id}
              tirage={tirage}
              displayData={displayData}
              locale={locale}
              t={t}
              isTirage={isTirage}
              trigger={
                <div className="w-full cursor-pointer hover:bg-gray-50 transition-colors rounded p-2 -m-2">
                  <div className="font-normal text-sm">{tirageSummary}</div>
                </div>
              }
            />
          );
        })}
      </AccordionContent>
    </AccordionItem>
  );
}
